var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUnderline = function SvgUnderline(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.778 4.389a.778.778 0 0 0-1.556 0v8.167a7.778 7.778 0 1 0 15.556 0V4.389a.778.778 0 1 0-1.555 0v8.167a6.222 6.222 0 0 1-12.445 0V4.389ZM4.667 23.833a.778.778 0 1 0 0 1.556h18.667a.778.778 0 0 0 0-1.556H4.667Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUnderline);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyOCAyOCI+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03Ljc3OCA0LjM4OWEuNzc4Ljc3OCAwIDAgMC0xLjU1NiAwdjguMTY3YTcuNzc4IDcuNzc4IDAgMSAwIDE1LjU1NiAwVjQuMzg5YS43NzguNzc4IDAgMSAwLTEuNTU1IDB2OC4xNjdhNi4yMjIgNi4yMjIgMCAwIDEtMTIuNDQ1IDBWNC4zODlaTTQuNjY3IDIzLjgzM2EuNzc4Ljc3OCAwIDEgMCAwIDEuNTU2aDE4LjY2N2EuNzc4Ljc3OCAwIDAgMCAwLTEuNTU2SDQuNjY3WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPg==";